import { ref, watch } from 'vue'
import CUSTOMERS from '@customers/customers.json'

// load stored customer if running locally
if (process.env.NODE_ENV === 'development') {
  const sessionCustomer = sessionStorage.getItem('customer')
  if (sessionCustomer) window.siteVars.orgName = sessionCustomer
}

const customerIds = CUSTOMERS.map(c => c.id)
let initialCustomer = window?.siteVars?.orgName || 'internal'
if (initialCustomer === 'intranet') initialCustomer = 'internal'
const customer = ref(initialCustomer)
const environmentLevel = ref(window?.siteVars?.env?.context || 'dev')

export function useCustomerManager () {
  const setCustomer = (newCustomer) => {
    if (!customerIds.includes(newCustomer)) {
      console.error(`Customer not found. Existing customers are: ${customerIds.join(', ')}`)
      return
    }

    customer.value = newCustomer

    if (process.env.NODE_ENV === 'development') {
      sessionStorage.setItem('customer', newCustomer)
    }
  }

  watch(customer, (newCustomer) => {
    window.siteVars.orgName = newCustomer
  })

  return {
    CUSTOMERS,
    customer,
    setCustomer,
    environmentLevel,
  }
}
